/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Document_Still_SigningInputs */

const vi_einvoice_document_still_signing = /** @type {(inputs: Einvoice_Document_Still_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA đang ký hóa đơn. Vui lòng xem lại sau vài phút.`)
};

/**

* @param {Einvoice_Document_Still_SigningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_document_still_signing = /** @type {((inputs?: Einvoice_Document_Still_SigningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Document_Still_SigningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_document_still_signing(inputs)
});